import React, { useState, useEffect } from 'react';
import axios from 'axios';

import classes from './Question.module.scss';

const Question = ({ question, index }) => {
  const [loading, setLoading] = useState(true);
  const [translation, setTranslation] = useState();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const hiddenAnswers = urlParams.get('hiddenAnswers');
  console.log(hiddenAnswers);

  useEffect(() => {
    axios
      .post('https://translator.andremiguelaa.com/api/translations', {
        text: question.question,
        targetLang: 'pt-PT',
      })
      .then((response) => {
        if (response.data.sourceLang === 'en') {
          setTranslation(response.data.translation);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [question]);

  if (loading) {
    return null;
  }

  return (
    <div className={classes.question}>
      <strong>Pergunta {index + 1}:</strong>
      <br />
      <br />
      <div>
        {translation && (
          <>
            <strong>Enunciado original</strong>
            <br />
            <br />
          </>
        )}
        {question.question}
        <br />
        {translation && (
          <>
            <br />
            <strong>Tradução automática</strong>
            <br />
            <br />
            {translation}
            <br />
          </>
        )}
      </div>
      <br />
      <button
        onClick={() => {
          if (!translation) {
            navigator.clipboard.writeText(question.question);
          } else {
            navigator.clipboard.writeText(`Enunciado original:

${question.question}

Tradução automática:

${translation}`);
          }
        }}
      >
        Copiar enunciado
      </button>
      <br />
      <br />
      <strong>Resposta:</strong>
      <br />
      <br />
      {!hiddenAnswers && (
        <>
          {question.answer}
          <br />
        </>
      )}
      <button
        onClick={() => {
          navigator.clipboard.writeText(question.answer);
        }}
      >
        Copiar resposta
      </button>
    </div>
  );
};

export default Question;
